import './App.css';
import AnmeldungProcessor from "./components/AnmeldungProcessor";


function App() {
  return <AnmeldungProcessor />;
}

export default App;
